import React, { useEffect } from 'react'
import { Container } from '@chakra-ui/react'
import { useRouter } from 'next/router'
import MainLayout from '@layouts/main-layout'
import VerifyOtp from '@components/auth/verify-otp'
import RouterUrl from '@constants/router.constant'
import { OTP_DISABLED } from '@constants/auth.constant'
import { NextPageWithLayout } from 'types/global'

const VerifyPhonePage: NextPageWithLayout = () => {
  const router = useRouter()

  // TEMP (OTP disabled): bypass the verify-phone page, redirect to home.
  // Remove this block (and set OTP_DISABLED=false) to restore.
  useEffect(() => {
    if (OTP_DISABLED) {
      router.replace(RouterUrl.HOME.ROOT)
    }
  }, [router])

  if (OTP_DISABLED) {
    return null
  }

  return (
    <>
      <Container>
        <VerifyOtp />
      </Container>
    </>
  )
}

VerifyPhonePage.getLayout = (page) => {
  return <MainLayout>{page}</MainLayout>
}

export default VerifyPhonePage
